import * as React from "react";

import { LOADING, ActionSource } from "common/components/types";
import UserProfile from "../ui/smart/user-profile/user-profile";
import { loadedDefinedMap, asString, asBoolean } from "common/components/component-helpers";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useForce } from "hooks/use-force";
import { GlideFunctionalRenderer } from "common/components/uis";
import { dontAwait } from "@glideapps/ts-necessities";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";
import { useNetworkStatus } from "hooks/use-network-status";

export const UserProfileMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[image, onChange, isEnabled, titleValue, subtitleValue, removeBrandingValue], [imageVP]] =
        useForceValueProducers(getValueProducers, force, ctx);
    const { onClick: onImageChangeCB } = useOnClickFromAction(onChange, ActionSource.UserProfile, ctx, env);
    const onLine = useNetworkStatus();

    // TODO: Should this be a skeleton specific to the user profile?

    const enabled = onLine && isEnabled === true;

    const onImageChange = React.useCallback(
        (newImageURL: string) => {
            if (imageVP !== undefined && onImageChangeCB !== undefined && enabled) {
                imageVP.set(newImageURL);
                dontAwait(onImageChangeCB(undefined));
            }
        },
        [imageVP, enabled, onImageChangeCB]
    );

    if (image === LOADING || isEnabled === LOADING || titleValue === LOADING || subtitleValue === LOADING) {
        return env.renderProgress();
    }

    const imageURL = loadedDefinedMap(image, asString);
    const title = loadedDefinedMap(titleValue, asString);
    const subtitle = loadedDefinedMap(subtitleValue, asString);
    const removeBranding = loadedDefinedMap(removeBrandingValue, asBoolean);

    if (title === undefined && subtitle === undefined && imageURL === undefined) {
        return null;
    }

    return (
        <UserProfile
            showBranding={removeBranding !== true && !env.appEnvironment.eminenceFlags.removeBranding}
            title={title}
            subtitle={subtitle}
            imageURL={imageURL}
            onImageChange={enabled ? onImageChange : undefined}
            canUploadImage={enabled}
        />
    );
};
